package pl.decks.personal.components.widgets.ranks.electric

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import pl.decks.personal.components.widgets.ranks.Rank
import pl.decks.personal.theme.SitePalette
import pl.decks.personal.extensions.toSitePalette

enum class BatteryRank(
    override val slot: Rank.Slot,
    override val title: String,
    private val coloring: (SitePalette) -> SitePalette.BatteryColors,
) : Rank {
    F1(Rank.Slot.S1, "Unplugged", { it.battery.empty }),
    F2(Rank.Slot.S2, "Few percents", { it.battery.low }),
    F3(Rank.Slot.S3, "Running low", { it.battery.low }),
    F4(Rank.Slot.S4, "Powerful enough", { it.battery.mid }),
    F5(Rank.Slot.S5, "Halfway", { it.battery.mid }),
    F6(Rank.Slot.S6, "Something to work with", { it.battery.mid }),
    F7(Rank.Slot.S7, "Resourceful", { it.battery.high }),
    F8(Rank.Slot.S8, "Not much left there", { it.battery.high }),
    F9(Rank.Slot.S9, "Overcharged", { it.battery.full }),
    ;

    @Composable
    override fun render(modifier: Modifier) = BatteryBadge(
        rank = this,
        coloring = coloring(ColorMode.current.toSitePalette()),
        strokeFraction = 0.1f,
        capHeight = 0.08f,
        modifier = modifier,
    )

}
